import React from 'react';
import PropTypes from 'prop-types';
import { INBOX_MSG_TYPES } from '../../services/utilityFunctions';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import TeamProp from '../../commonComponents/propTypes/teamProp';
import translate from '../../commonComponents/translate';
import InboxMessageForm from './create/InboxMessageForm';

function InboxCreate({ t, type, teams }) {
  return (
    <Title title={t('inboxDetails_head_createTitle')}>
      <ContentContainer>
        <SubHeader
          title={t('inboxDetails_createTitle')}
          breadcrumbs={[
            { link: '/dashboard', text: t('header_inbox') },
            { link: '', text: t('inboxDetails_createTitle') },
          ]}
        />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__body">
                  <InboxMessageForm type={type} teams={teams} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

InboxCreate.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.oneOf(INBOX_MSG_TYPES).isRequired,
  teams: PropTypes.arrayOf(PropTypes.shape(TeamProp.propType)).isRequired,
};

export default translate(InboxCreate);
